<template>
    <div class="row">
        <div class="col-12">
            <div class="form-group pb-1">
                <div class="checkbox-container mb-3 pb-1">
                    <input
                        type="checkbox"
                        name="privacidad"
                        id="privacidad"
                        data-cy="acepta-privacidad"
                        :disabled="desactivar"
                        :class="!privacidad && error ? 'is-invalid' : ''"
                        v-model="privacidad"
                        @change="condicionesAceptadas"
                    />
                    <label 
                        for="privacidad" 
                        :class="[carrito ? 'with-before' : '']"
                    >
                        {{ $t('formularios.he_leido') }}
                        <router-link :to="{ name: 'legal' }" target="_blank">
                            <span>{{ $t('formularios.terminos_condiciones') }}</span>
                        </router-link>
                        y la
                        <router-link :to="{ name: 'privacidad' }" target="_blank">
                            <span>{{ $t('formularios.politica_privacidad') }}</span>
                        </router-link>
                    </label>
                </div>
                <span class="error" v-if="!privacidad && error">{{ $t('formularios.error_terminos') }}</span>
            </div>
            <div class="form-group pb-1">
                <div class="checkbox-container mb-3 pb-1">
                    <input
                        type="checkbox"
                        name="condiciones"
                        id="condiciones"
                        data-cy="acepta-condiciones"
                        :disabled="desactivar"
                        :class="!condiciones && error ? 'is-invalid' : ''"
                        v-model="condiciones"
                        @change="condicionesAceptadas"
                    />
                    <label for="condiciones" :class="[carrito ? 'with-before' : '']">{{ $t('formularios.acepto') }}
                        <router-link :to="{ name: 'condiciones_generales'}" target="_blank">
                            <span>{{ $t('formularios.condiciones') }}</span>
                        </router-link>
                    </label>
                </div>
                <span class="error" v-if="!condiciones && error">{{ $t('formularios.error_condiciones') }}</span>
            </div>
            <div class="form-group pb-1" v-if="mostrarCheckComunicaciones">
                <div class="checkbox-container mb-3 pb-1">
                    <input
                        type="checkbox"
                        name="comunicaciones"
                        id="comunicaciones"
                        data-cy="acepta-comunicaciones"
                        :disabled="desactivar"
                        v-model="comunicaciones"
                        @change="condicionesAceptadas"
                    />
                    <label for="comunicaciones" :class="[carrito ? 'with-before' : '']">
                        {{ $t(teatro.hash === '7IzXuJcTytAub9imoikD' ? 'formularios.acepto_comunicaciones_malecon' : (teatro.hash === '5mWE2j1zaGfV4hSw4KhH' ? 'formularios.acepto_comunicaciones_con_marcas_asociadas' :'formularios.acepto_comunicaciones'), { teatro: getNombreTeatro() })}}
                    </label>
                </div>
                <span class="error" v-if="comunicacionesObligatorias && !comunicaciones && error">{{ $t('formularios.error_comunicaciones') }}</span>
            </div>
            <div class="form-group pb-1" v-if="pago_plazos">
                <div class="checkbox-container mb-4">
                    <input 
                        type="checkbox" 
                        name="plazos" 
                        id="plazos" 
                        :disabled="desactivar" 
                        v-model="plazos"
                        @change="condicionesAceptadas"
                    />
                    <label for="plazos">
                        {{ $t('formularios.acepto_plazos') }}
                        <b>
                            <span class="underline m-0 p-0" @click="showModal('condiciones-plazos')">{{
                                $t('formularios.condiciones_plazos') }}
                            </span>
                        </b>
                        {{ $t('formularios.pago_plazos') }}
                    </label>
                </div>
                <span class="error" v-if="!plazos && error">{{ $t('formularios.error_condiciones_plazos') }}</span>
                <CondicionesPlazosModal 
                    :condiciones_plazos="condiciones_plazos" 
                    :texto_condiciones="texto_condiciones"
                    @close="closeModal"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import CondicionesPlazosModal from './modals/CondicionesPlazosModal';
    import { TEATRO_HASH_ECLECTICA } from '@/constants/teatros';

    export default {
        props: ['error', 'pago_plazos', 'condiciones_plazos', 'texto_condiciones', 'desactivar', 'carrito', 'comunicacionesObligatorias'],
        data() {
            return {
                privacidad: false,
                condiciones: false,
                comunicaciones: false,
                plazos: false,
            }
        },
        created() {
            // Eclectica no muestra la casilla: su alta ya incluye las comunicaciones.
            if (!this.mostrarCheckComunicaciones) {
                this.comunicaciones = true;
            }
        },
        methods: {
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            condicionesAceptadas() {
                let continuar = false;

                if (this.privacidad && this.condiciones) {
                    continuar = true;

                    if (this.pago_plazos && !this.plazos) {
                        continuar = false;
                    }
                }

                this.$emit(
                    'continuar',
                    continuar,
                    this.privacidad,
                    this.condiciones,
                    this.comunicaciones,
                    this.plazos,
                    this.renovacion_automatica
                );
            },
            getNombreTeatro() {
                if(this.evento_id == 14878 || this.evento_id == 14876) {
                    return 'POWERED BY SHAREMUSIC';
                }
                return this.teatro.nombre;
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            evento_id() {
                return parseInt(this.$route.params.event_id);
            },
            mostrarCheckComunicaciones() {
                return this.teatro?.hash !== TEATRO_HASH_ECLECTICA;
            }
        },
        components: {
            CondicionesPlazosModal
        }
    }
</script>
<style scoped>
.with-before::before {
    background: white !important;
}
</style>